var _defs, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgLogo(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 120.8 36",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:none;}.cls-2{clip-path:url(#clip-path);}.cls-3{fill:url(#\u0411\u0435\u0437\u044B\u043C\u044F\u043D\u043D\u044B\u0439_\u0433\u0440\u0430\u0434\u0438\u0435\u043D\u0442_2);}.cls-4{clip-path:url(#clip-path-2);}.cls-5{fill:url(#\u0411\u0435\u0437\u044B\u043C\u044F\u043D\u043D\u044B\u0439_\u0433\u0440\u0430\u0434\u0438\u0435\u043D\u0442_3);}.cls-6{clip-path:url(#clip-path-3);}.cls-7{fill:url(#\u0411\u0435\u0437\u044B\u043C\u044F\u043D\u043D\u044B\u0439_\u0433\u0440\u0430\u0434\u0438\u0435\u043D\u0442_4);}.cls-8{clip-path:url(#clip-path-4);}.cls-9{fill:url(#\u0411\u0435\u0437\u044B\u043C\u044F\u043D\u043D\u044B\u0439_\u0433\u0440\u0430\u0434\u0438\u0435\u043D\u0442_8);}.cls-10{clip-path:url(#clip-path-5);}.cls-11{fill:url(#\u0411\u0435\u0437\u044B\u043C\u044F\u043D\u043D\u044B\u0439_\u0433\u0440\u0430\u0434\u0438\u0435\u043D\u0442_6);}.cls-12{clip-path:url(#clip-path-6);}.cls-13{fill:url(#\u0411\u0435\u0437\u044B\u043C\u044F\u043D\u043D\u044B\u0439_\u0433\u0440\u0430\u0434\u0438\u0435\u043D\u0442_7);}.cls-14{fill:#fff;}.cls-15{clip-path:url(#clip-path-7);}.cls-16{fill:url(#\u0411\u0435\u0437\u044B\u043C\u044F\u043D\u043D\u044B\u0439_\u0433\u0440\u0430\u0434\u0438\u0435\u043D\u0442_8-2);}"), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "14.48 8.92 14.48 3.34 7.09 6.04 14.48 8.92"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "\\u0411\\u0435\\u0437\\u044B\\u043C\\u044F\\u043D\\u043D\\u044B\\u0439_\\u0433\\u0440\\u0430\\u0434\\u0438\\u0435\\u043D\\u0442_2",
    x1: 1753.36,
    y1: 5921.26,
    x2: 1753.46,
    y2: 5921.26,
    gradientTransform: "matrix(-216.1, 0, 0, 216.1, 378924.78, -1279594.48)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#29abe2"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-2"
  }, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "3.8 13.31 14.48 8.92 14.48 28.33 3.8 13.31"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "\\u0411\\u0435\\u0437\\u044B\\u043C\\u044F\\u043D\\u043D\\u044B\\u0439_\\u0433\\u0440\\u0430\\u0434\\u0438\\u0435\\u043D\\u0442_3",
    x1: 1784.08,
    y1: 5955.75,
    x2: 1784.18,
    y2: 5955.75,
    gradientTransform: "matrix(0, -202.61, -202.61, 0, 1206677.74, 361495.65)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#00ceff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#00519d"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-3"
  }, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "7.09 6.04 14.48 8.92 3.8 13.31 7.09 6.04"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "\\u0411\\u0435\\u0437\\u044B\\u043C\\u044F\\u043D\\u043D\\u044B\\u0439_\\u0433\\u0440\\u0430\\u0434\\u0438\\u0435\\u043D\\u0442_4",
    x1: 1752.27,
    y1: 5924.51,
    x2: 1752.38,
    y2: 5924.51,
    gradientTransform: "matrix(-244.18, 0, 0, 244.18, 427890.01, -1446634.28)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#6df"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0071bc"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-4"
  }, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "14.48 14.51 14.48 8.92 21.87 11.62 14.48 14.51"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "\\u0411\\u0435\\u0437\\u044B\\u043C\\u044F\\u043D\\u043D\\u044B\\u0439_\\u0433\\u0440\\u0430\\u0434\\u0438\\u0435\\u043D\\u0442_8",
    x1: 1732.18,
    y1: 5934.37,
    x2: 1732.29,
    y2: 5934.37,
    gradientTransform: "matrix(0, 216.1, -216.1, 0, 1282452.23, -374324.53)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#9fe2ff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2986e2"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-5"
  }, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "25.16 18.89 14.48 14.51 14.48 33.91 25.16 18.89"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "\\u0411\\u0435\\u0437\\u044B\\u043C\\u044F\\u043D\\u043D\\u044B\\u0439_\\u0433\\u0440\\u0430\\u0434\\u0438\\u0435\\u043D\\u0442_6",
    x1: 1779,
    y1: 5929.67,
    x2: 1779.1,
    y2: 5929.67,
    gradientTransform: "translate(-360427.87 -1201361.43) scale(202.61)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#0098d6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#003386"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-6"
  }, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "21.87 11.62 14.48 14.51 25.16 18.89 21.87 11.62"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "\\u0411\\u0435\\u0437\\u044B\\u043C\\u044F\\u043D\\u043D\\u044B\\u0439_\\u0433\\u0440\\u0430\\u0434\\u0438\\u0435\\u043D\\u0442_7",
    x1: 1734.24,
    y1: 5937.19,
    x2: 1734.34,
    y2: 5937.19,
    gradientTransform: "translate(1449758.42 -423461.82) rotate(90) scale(244.18)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#4abaff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#00519c"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-7"
  }, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "14.48 14.51 15.87 9.43 14.48 8.92 14.48 14.51"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "\\u0411\\u0435\\u0437\\u044B\\u043C\\u044F\\u043D\\u043D\\u044B\\u0439_\\u0433\\u0440\\u0430\\u0434\\u0438\\u0435\\u043D\\u0442_8-2",
    x1: 1751.46,
    y1: 5784.25,
    x2: 1751.57,
    y2: 5784.25,
    gradientTransform: "matrix(-35.81, 0, 0, 35.81, 62734.34, -207111.42)",
    xlinkHref: "#\\u0411\\u0435\\u0437\\u044B\\u043C\\u044F\\u043D\\u043D\\u044B\\u0439_\\u0433\\u0440\\u0430\\u0434\\u0438\\u0435\\u043D\\u0442_8"
  }))), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "\u0420\u0435\u0441\u0443\u0440\u0441 6") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "\\u0421\\u043B\\u043E\\u0439_2",
    "data-name": "\\u0421\\u043B\\u043E\\u0439 2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "\\u0421\\u043B\\u043E\\u0439_1-2",
    "data-name": "\\u0421\\u043B\\u043E\\u0439 1"
  }, /*#__PURE__*/React.createElement("g", {
    className: "cls-2"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-3",
    x: 6.17,
    y: 1.8,
    width: 9.23,
    height: 8.67,
    transform: "translate(-1.61 6.71) rotate(-32.28)"
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-4"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 1.97,
    y: 8.05,
    width: 14.34,
    height: 21.15,
    transform: "translate(-3.54 2.2) rotate(-11.54)"
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-6"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-7",
    x: 2.68,
    y: 3.61,
    width: 12.91,
    height: 12.13,
    transform: "translate(-3.92 7.13) rotate(-35.61)"
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-8"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-9",
    x: 13.84,
    y: 7.1,
    width: 8.67,
    height: 9.23,
    transform: "translate(-1.43 20.83) rotate(-57.72)"
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-10"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-11",
    x: 9.24,
    y: 17.04,
    width: 21.15,
    height: 14.34,
    transform: "translate(-7.87 38.78) rotate(-78.46)"
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-12"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-13",
    x: 13.75,
    y: 8.8,
    width: 12.13,
    height: 12.91,
    transform: "translate(-4.13 22.48) rotate(-54.39)"
  })), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-14",
    points: "14.48 8.92 14.48 8.73 7.09 6.04 14.48 8.92"
  }), /*#__PURE__*/React.createElement("g", {
    className: "cls-15"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-16",
    x: 13.21,
    y: 8.93,
    width: 3.92,
    height: 5.56,
    transform: "translate(-3.77 8.81) rotate(-28.95)"
  })), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-14",
    points: "95.03 6.95 87.01 6.95 86.75 8.61 89.79 8.61 89.79 16.94 92.01 16.94 92.01 8.61 94.76 8.61 95.03 6.95"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-14",
    points: "92.26 22.46 85.71 22.46 85.63 22.94 88.67 22.94 88.67 32.31 89.2 32.31 89.2 22.94 92.19 22.94 92.26 22.46"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-14",
    d: "M55.58,12.64a2.77,2.77,0,0,0,2.07-2.71c0-2-1.42-3-4.21-3H49.93l.24,1.5v8.5h2.22V13h1.14l2.23,3.91h2.53Zm-2-1.12H52.39V8.46h1c1.35,0,2,.45,2,1.47s-.63,1.59-1.79,1.59"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-14",
    d: "M78.44,6.94H75l.24,1.47v8.53h2.22V13.53h1.19c2.39,0,4.11-1,4.11-3.36S81.1,6.94,78.44,6.94m0,5h-1V8.48h1c1.3,0,2,.52,2,1.69,0,1.35-.77,1.8-2,1.8"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-14",
    d: "M41.69,27.63c1.42-.3,2.34-1,2.34-2.57s-1.07-2.6-3.49-2.6h-2.4l.06.39v9.46h.53V27.72h2.4l2.8,4.59h.63Zm-1-.37H38.73V22.91H40.5c2.17,0,3,.76,3,2.15s-1,2.2-2.82,2.2"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-14",
    d: "M66.47,27.08a2,2,0,0,0,1.86-2.18c0-1.65-1.3-2.44-3.52-2.44H62.56l.06.39v9.46H65.4c2.17,0,3.44-1,3.44-2.69a2.33,2.33,0,0,0-2.37-2.54m-3.32-4.16h1.72c1.87,0,2.92.61,2.92,2a2,2,0,0,1-2.19,2H63.15Zm2.26,8.93H63.15V27.33h2.52c1.53,0,2.63.72,2.63,2.29s-1.09,2.23-2.89,2.23"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-14",
    d: "M45.28,7.8,44.18,9a3,3,0,0,0-1.91-.7c-1.4,0-2.43,1-2.43,3.61s1,3.57,2.45,3.57a3.39,3.39,0,0,0,2.08-.81l1,1.22a4.57,4.57,0,0,1-3.2,1.26c-2.8,0-4.7-1.83-4.7-5.24s2-5.22,4.65-5.22A4.61,4.61,0,0,1,45.28,7.8"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-14",
    points: "67.17 13.17 67.17 16.94 64.95 16.94 64.95 13.19 61.6 6.95 64.03 6.95 66.12 11.48 68.19 6.95 70.53 6.95 67.17 13.17"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-14",
    d: "M108.13,11.94c0,3.28-1.77,5.23-4.64,5.23s-4.65-1.89-4.65-5.23,1.78-5.23,4.65-5.23,4.64,1.88,4.64,5.23m-6.95,0c0,2.62.86,3.64,2.31,3.64s2.29-1,2.29-3.64S105,8.3,103.49,8.3s-2.31,1-2.31,3.64"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-14",
    d: "M57.1,27.4c0,3.21-1.57,5.06-4.09,5.06s-4.1-1.8-4.1-5.05S50.59,22.3,53,22.3s4.09,1.76,4.09,5.1m-7.64,0c0,3,1.46,4.58,3.55,4.58s3.55-1.56,3.55-4.59S55.14,22.78,53,22.78s-3.55,1.54-3.55,4.63"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-14",
    d: "M81.82,27.4c0,3.21-1.57,5.06-4.09,5.06s-4.1-1.8-4.1-5.05,1.68-5.11,4.1-5.11,4.09,1.76,4.09,5.1m-7.64,0c0,3,1.46,4.58,3.55,4.58s3.55-1.56,3.55-4.59-1.42-4.62-3.55-4.62-3.55,1.54-3.55,4.63"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-14",
    x: 97.26,
    y: 22.46,
    width: 0.53,
    height: 9.85
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-14",
    d: "M109.87,23.17l-.29.36a3.25,3.25,0,0,0-2.18-.75c-2,0-3.58,1.34-3.58,4.61,0,3.09,1.57,4.59,3.52,4.59a3.31,3.31,0,0,0,2.34-.84l.31.36a3.91,3.91,0,0,1-2.66,1c-2.31,0-4-1.76-4-5.06s1.83-5.09,4.09-5.09a3.6,3.6,0,0,1,2.5.87"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-14",
    d: "M120.49,23.36l-.34.34a3.37,3.37,0,0,0-2.44-.92c-1.44,0-2.35.75-2.35,1.85s.67,1.63,2.51,2.16c2,.58,2.93,1.23,2.93,2.86s-1.33,2.8-3.23,2.8a4.6,4.6,0,0,1-3.16-1.19l.34-.35A4,4,0,0,0,117.56,32c1.61,0,2.71-.89,2.71-2.31s-.69-1.89-2.59-2.45c-2.09-.62-2.86-1.27-2.86-2.6s1.13-2.33,2.87-2.33a3.91,3.91,0,0,1,2.8,1.06"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogo);
export default __webpack_public_path__ + "static/media/logo.6c4aebdd11ec190b71b4f7d9c95aad1f.svg";
export { ForwardRef as ReactComponent };